import Splide from '@splidejs/splide';
import { Fancybox } from "@fancyapps/ui";

jQuery( function($){

    class Custom_Image_Gallery{

        constructor(gallery){

            this.colour_attribute   = 'attribute_pa_colour';
            this.form               = document.querySelector('form.variations_form');
            this.loader             = gallery.querySelector('.loader');
            this.has_gallery        = gallery.classList.contains('has-gallery');
            this.slider; // slide slider
            this.thumbnails; // slide slider
            this.current_colour; // current colour showing on frontend
            this.simplebox;
            this.images = [];
            // this.swatches = this.form.querySelectorAll( '.variation-buttons input' );

            // Waits until we have the images before running the rest of the code
            this.get_images().then( response => {

                // all the gallery images from ACF repeater
                this.images = response;
                
                this.init_gallery();

                // listens to the form changes and only runs when the colour filter changes
                this.form.addEventListener( 'change', this.maybe_update_gallery.bind(this) );

                // // Listen to swatch change to trigger the default Woocommerce dropdown
                // if( this.swatches ){
                //     Array.from(this.swatches).forEach( swatch => swatch.addEventListener('change', this.handle_swatch_change.bind(this) )  )
                // }

            } );
        
        }


        /**
         * 
         * Gets the image URLs from the ACF repeater in the product backend
         * @returns Array
         */
        async get_images(){
            let response;
			try {
				response = await $.ajax( ajaxObject.ajaxurl, {
					type: 'GET',
					data: {
						action: "get_gallery_images",
						id: this.form.dataset.product_id,
						_wpnonce: ajaxObject.ajaxnonce,
					}
				})

				return response.data;
				
			} catch (error) {
				console.log(error);
			}
        }


        /**
         * 
         * initialses the main slider and the thumbnail nav
         * 
         * https://splidejs.com/tutorials/thumbnail-carousel/
         */
        init_gallery(){
    
            // Main slider
            this.slider = new Splide( '.splide.main', {
                pagination : false,
                arrows     : false,
                cover      : true,
                with       : '100%'
            } );
    
            // Thumbnail slider
            this.thumbnails = new Splide( '.splide.thumbnails', {
                fixedWidth      : '15%',
                isNavigation    : true, 
                rewind          : true,
                pagination      : false,
                cover           : true,
                arrows          : true,
                gap: '2%',
                breakpoints: {
                    600: {
                        fixedWidth : '23.5%'
                    }
                }
            } );
    
            this.slider.sync( this.thumbnails );
            this.slider.mount();
            this.thumbnails.mount();

            const formdata = new FormData(this.form);
            
            if( formdata.get( this.colour_attribute ) ){
                this.current_colour = formdata.get( this.colour_attribute );
            }

            $(this.loader).fadeOut(400);

            this.update_custom_gallery();

        }


        /**
         * 
         * Only update images if the colour is different to avoid flickering
         * @param {Event} e 
         */
        maybe_update_gallery(e){

            const field_name = e.target.name;
            const colour = e.target.value;

            if( this.colour_attribute == field_name && this.current_colour != colour  ){
                this.current_colour = colour;
                this.update_custom_gallery();
            }

        }


        /**
         * 
         * Updates the images in the gallery
         * 
         */
        update_custom_gallery(){

            let images;

            // show placeholder because no images found
            if( true == this.images.hasOwnProperty('placeholder') ){

                images = [{url: this.images.placeholder}]

            }else{

                if( this.current_colour ){
                    images = this.images[this.current_colour];
                }
    
                // show default image if image not in backend or other cases
                if( ! images ){
                    images = this.images['default_images'];
                }
    
            }

            this.slider.remove( '.splide__slide' );
    
            if( this.thumbnails.length > 0 ){
                this.thumbnails.remove( '.splide__slide' );
            }

            images.forEach( image => {

                let html = '<li class="splide__slide">';
                html += '<a href=\''+ image.url +'\' data-fancybox="gallery">';
                html += '<picture class="attachment-medium size-medium image" decoding="async" loading="lazy">';
                html += '<img width="600" height="600" src=\'' + image.url + '\' alt="" decoding="async" loading="lazy"></img>';
                html += '</picture>';
                html += '</a>';
                html += '</li>';

                this.slider.add(html);
                
                let thumb_html = '<li class="splide__slide">';
                thumb_html += '<picture class="attachment-medium size-medium image" decoding="async" loading="lazy">';
                thumb_html += '<img width="300" height="300" src=\'' + image.url + '\' alt="" decoding="async" loading="lazy"></img>';
                thumb_html += '</picture>';
                thumb_html += '</li>';

                this.thumbnails.add(thumb_html);

            });

            this.slider.refresh();
            this.thumbnails.refresh();

            // if(this.thumbnails.length == 1){
            //     this.thumbnails.root.style.opacity = 0;
            // }else{
            //     this.thumbnails.root.style.opacity = 1;
            // }

            // lightbox 
            // https://fancyapps.com/fancybox/api/options/
            Fancybox.bind('[data-fancybox="gallery"]', {
                caption: false,
                animated: false
            });

        }


        // /**
        //  * 
        //  * Update the main WC dropdown when the swatch changes to trigger the variation change
        //  * @param {Event} e 
        //  */
        // handle_swatch_change(e) {

        //     const swatch = e.target;

        //     var select = this.form.querySelector('select[name="' + swatch.name + '"]');
        //     var selected_option = select.querySelector('option[value="' + swatch.value + '"]');

        //     if (selected_option) {
        //         selected_option.selected = true;
        //         $(select).change();
        //     }

        // }

    }


    // Starts the gallery function
    const gallery = document.querySelector('.woocommerce-product-gallery.custom');

    if( gallery ){
        new Custom_Image_Gallery( gallery );
    }

} )